import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6l0 -3","key":"svg-0"}],["path",{"d":"M6 12l-3 0","key":"svg-1"}],["path",{"d":"M7.75 7.75l-2.15 -2.15","key":"svg-2"}]]

const IconLoaderQuarter = createReactComponent('outline', 'loader-quarter', 'LoaderQuarter', __iconNode);

export default IconLoaderQuarter;